module.exports = __webpack_public_path__ + "assets/c3fe5d53be6a6fbf923b5578e92e1f74.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/next.mp3
 ** module id = 486
 ** module chunks = 0
 **/